import { z } from 'zod';
import { ROLES } from './auth-types.js';
export const SignUpSchema = z.object({
    email: z.string().email(),
    password: z.string().min(12),
    name: z.string().min(1),
});
export const OrgCreateSchema = z.object({
    name: z.string().min(2).max(80),
    slug: z
        .string()
        .min(2)
        .max(40)
        .regex(/^[a-z0-9-]+$/),
    countryCode: z.string().length(2).default('EC'),
    baseCurrency: z.string().length(3).default('USD'),
});
export const InviteMemberSchema = z.object({
    email: z.string().email(),
    role: z.enum(ROLES),
});
export const ChangeRoleSchema = z.object({
    role: z.enum(ROLES),
});
export const OrgSwitchSchema = z.object({
    orgId: z.string().min(1),
});
//# sourceMappingURL=validators.js.map